import { useQuery } from 'react-query'

import { QUERY_KEYS } from 'src/constants'
import { rewardActivityService } from 'src/services/reward-activity.service'

export const useGetRewardActivityChallenges = () => {
  return useQuery(
    [QUERY_KEYS.REWARD_ACTIVITY_CHALLENGES],
    () => rewardActivityService.getRewardActivityChallenges(),
    {
      keepPreviousData: true,
    },
  )
}
